import { ensure, ensureArray, stringType, TType } from "types";

import {
  configDatabaseRecordType,
  configIdType,
  configPageableMetaType,
  IDatabaseRecord,
  IId,
  IPageable,
  IPartialPageable,
} from "@/core/api";

export interface ISkill extends IId {
  name: string;
}

export const configSkillType: TType<ISkill> = {
  ...configIdType,
  name: stringType(""),
};

export const skillType = ensure(configSkillType);

export const skillListType = ensureArray(skillType);

export interface ICreateSkillDto {
  name: string;
}

export interface ISkillCategory extends IId {
  name: string;
  iconName: string;
}

export const configSkillCategoryType: TType<ISkillCategory> = {
  ...configIdType,
  name: stringType(""),
  iconName: stringType(""),
};

export const skillCategoryType = ensure(configSkillCategoryType);

export interface IPageableSkill extends IPageable<ISkill[]> {}

export const pageableSkillTypeConfig: TType<IPageableSkill> = {
  ...configPageableMetaType,
  content: ensureArray(skillType),
};

export const pageableSkillType = ensure(pageableSkillTypeConfig);

export interface IPartialPageableSkill extends IPartialPageable<ISkill[]> {}

export interface ISkillWithPriority extends IDatabaseRecord {
  skill: ISkill;
  priority: "REQUIRED" | "PREFERRED";
}

const configSkillWithPriorityType: TType<ISkillWithPriority> = {
  ...configDatabaseRecordType,
  skill: skillType,
  priority: stringType(""),
};

export const skillWithPriorityType = ensure(configSkillWithPriorityType);
